import { Injectable } from '@angular/core';
import { Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { CampaignFacadeService } from '@uw/core/facades/campaign.facade.service';
import { CampaignStateService } from '@uw/core/services/campaign-state.service';
import { CampaignService } from '@uw/core/services/campaign.service';
import { Observable, of, filter, first, map, mergeMap, switchMap, take, tap } from 'rxjs';
import { UserFacadeService } from '../facades/user.facade.service';
import { CustomNavigationService } from '../custom-navigation.service';

@Injectable()
export class SelectDonorCampaignsListResolver  {

  constructor(protected campaignService: CampaignService,
    protected campaignStateService: CampaignStateService,
    protected userFacadeService: UserFacadeService,
    private customNavigationService: CustomNavigationService,
    protected campaignFacadeService: CampaignFacadeService,
    protected router: Router) {
  }

  resolve(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot,): Observable<boolean> {
    return this.userFacadeService.getAuthUser()
    .pipe(
      take(1),
      mergeMap(user=> {
        if (user && user.token) {
          return this.loadDonorList();
        } else {
          return of(true);
        }
      }),

    );
  }

  loadDonorList(){
    return this.campaignFacadeService.isDonorCampaignListLoaded.pipe(
      tap(loaded => {
        if (!loaded){
          this.campaignFacadeService.loadDonorCampaignList();
        }
      }),
      filter(loaded => loaded),
      switchMap(_loaded => this.campaignFacadeService.getDonorCampaignList().pipe(
        map(campaignList => {
          if(campaignList && campaignList.length == 1) {
            this.campaignStateService.setSelectedCampaign(campaignList[0]);
            this.campaignFacadeService.setCurrentCampaign(campaignList[0]);
            this.customNavigationService.navigate(['donor',campaignList[0].campaignGuid]); // in case of one active canpaign redirect the user to campaign
          }

          return true;

        })
      )),
      first()
    );
  }

}
